
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const CoreValues = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-16">
      <Card className="border-patrimoine-gold/20 shadow-lg hover:shadow-xl transition-shadow">
        <CardContent className="p-6">
          <h3 className="text-xl font-serif font-semibold text-patrimoine-dark mb-4">Expertise</h3>
          <p className="text-patrimoine-muted">
            Notre équipe possède une expérience approfondie dans tous les aspects de la gestion de patrimoine, avec des spécialistes dédiés à chaque domaine d'investissement.
          </p>
        </CardContent>
      </Card>
      <Card className="border-patrimoine-gold/20 shadow-lg hover:shadow-xl transition-shadow">
        <CardContent className="p-6">
          <h3 className="text-xl font-serif font-semibold text-patrimoine-dark mb-4">Personnalisation</h3>
          <p className="text-patrimoine-muted">
            Nous créons des solutions sur mesure adaptées aux objectifs spécifiques, à la tolérance au risque et à l'horizon temporel de chaque client.
          </p>
        </CardContent>
      </Card>
      <Card className="border-patrimoine-gold/20 shadow-lg hover:shadow-xl transition-shadow">
        <CardContent className="p-6">
          <h3 className="text-xl font-serif font-semibold text-patrimoine-dark mb-4">Innovation</h3>
          <p className="text-patrimoine-muted">
            Nous restons à l'avant-garde des tendances du marché et des opportunités d'investissement pour offrir des solutions innovantes et performantes.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CoreValues;
